export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14148.7bf6fe68.jpg";